package com.schoolconnect.app.feature.parentnotes

import com.schoolconnect.app.feature.attendance.ParentAttendanceChild
import com.schoolconnect.app.feature.common.PaginationPolicy

data class ParentPortalNotesState(
    val children: List<ParentAttendanceChild> = emptyList(),
    val selectedChildIndex: Int = 0,
    val rows: List<ParentNoteRowUi> = emptyList(),
    val search: String = "",
    val status: String = "All",
    val period: String = "All Time",
    val periodFrom: String = "",
    val periodTo: String = "",
    val teacherId: String = "",
    val teacherName: String = "All Teachers",
    val teacherOptions: List<ParentPortalTeacherOption> = emptyList(),
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val matchingCount: Int = 0,
    val sortField: ParentPortalNotesSortField = ParentPortalNotesSortField.LAST_ACTIVITY,
    val sortAscending: Boolean = false,
    val viewing: ParentNoteRowUi? = null,
    val viewingDetail: com.schoolconnect.app.datasource.network.response.ParentNoteResponse? = null,
    val viewingReplies: List<com.schoolconnect.app.datasource.network.response.ParentNoteReplyResponse> = emptyList(),
    val viewingConversationInfo: ParentConversationInfo = ParentConversationInfo(),
    val isLoading: Boolean = true,
    val errorMessage: String = "",
    val isViewingLoading: Boolean = false,
    val viewingError: String = "",
    val isSendingReply: Boolean = false,
    val replyResetGeneration: Int = 0,
    val historyScrollGeneration: Int = 0,
    val totalConversations: Int = 0,
    val unreadCount: Int = 0,
    val awaitingReplyCount: Int = 0,
    val activeCount: Int = 0
) {
    val selectedChild: ParentAttendanceChild? get() = children.getOrNull(selectedChildIndex)
}
data class ParentPortalTeacherOption(val id: String, val name: String)
enum class ParentPortalNotesSortField(val apiValue: String) {
    LAST_ACTIVITY("updated_at"),
    TEACHER("teacher_name"),
    TITLE("title"),
    STATUS("status")
}

sealed interface ParentPortalNotesEvent {
    data class ChildSelected(val index: Int) : ParentPortalNotesEvent
    data class SearchChanged(val value: String) : ParentPortalNotesEvent
    data class TeacherChanged(val option: ParentPortalTeacherOption?) : ParentPortalNotesEvent
    data class StatusChanged(val value: String) : ParentPortalNotesEvent
    data class PeriodChanged(val value: String) : ParentPortalNotesEvent
    data class CustomPeriodApplied(val from: String, val to: String) : ParentPortalNotesEvent
    data object FiltersCleared : ParentPortalNotesEvent
    data class PageChanged(val value: Int) : ParentPortalNotesEvent
    data class PageSizeChanged(val value: Int) : ParentPortalNotesEvent
    data class SortChanged(val field: ParentPortalNotesSortField) : ParentPortalNotesEvent
    data class ViewRequested(val row: ParentNoteRowUi) : ParentPortalNotesEvent
    data object ViewDismissed : ParentPortalNotesEvent
    data class ReplySubmitted(val message: String, val attachmentFileIds: List<String> = emptyList()) : ParentPortalNotesEvent
}
